type AddressBlockProps = {
  index: number;
  pickupPointName: string;
  address: {
    street: string;
    city: string;
    postCode: string;
  };
  distanceFromRefPoint: string;
};

const IndexPill: React.FC<{ index: number }> = ({ index }) => (
  <div className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-yellow-600">
    {index}
  </div>
);

export const AddressBlock: React.FC<AddressBlockProps> = ({
  index,
  pickupPointName,
  address,
  distanceFromRefPoint,
}) => {
  return (
    <div className="tw-flex tw-w-full tw-justify-between">
      <div className="tw-flex tw-gap-3">
        <IndexPill index={index} />
        <div>
          <div className="tw-lf-body-bold-md tw-capitalize">
            {pickupPointName.toLowerCase()}
          </div>
          <div className="tw-lf-body-regular-md tw-capitalize">
            {address.street.toLowerCase()}
          </div>
          <div className="tw-lf-body-regular-md tw-capitalize">{`${address.postCode.toLowerCase()} ${address.city.toLowerCase()}`}</div>
        </div>
      </div>
      <div className="tw-text-gra tw-lf-body-regular-md tw-text-[#9A9897]">{`${distanceFromRefPoint}km`}</div>
    </div>
  );
};
